const contra_turno = {
  path: "/carga-escolas-contraturno",
  redirect: "/carga-escolas-contraturno",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Escolas Contraturno",
  },
  children: [
    {
      path: "/carga-escolas-contraturno",
      name: "carga_escolas_contraturno",
      component: () =>
        import(
          "@/views/CargasDeEscolaContraTurno/CargasDeEscolaContraTurno.vue"
        ),
    },
  ],
};

export { contra_turno };
